import React from 'react';
import { ProfileDropdownContainer } from './profile-dropdown-container';

export const ProfileDropdown: React.FC = () => {
  return <ProfileDropdownContainer />;
};
